import { ReactNode } from 'react';

export type ButtonDescriptionPosition = 'top' | 'bottom';

export interface IButtonDescriptionProps {
  description: ReactNode;
  position?: ButtonDescriptionPosition;
}

const ButtonDescription = ({
  description,
  position = 'bottom',
}: IButtonDescriptionProps) => {
  return (
    <div className={`button-description button-description--${position}`}>
      <p>{description}</p>
    </div>
  );
};

export default ButtonDescription;
